var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgSpeakerOff = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 12,
    viewBox: "0 0 22 12",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 3L15 9M21 9L15 3L21 9Z",
    stroke: "#8B8B8B",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.33337 7.973V4.027C1.33337 3.64433 1.63204 3.33367 2.00004 3.33367H4.39071C4.47893 3.33335 4.56617 3.31518 4.64718 3.28023C4.72819 3.24528 4.80128 3.19429 4.86204 3.13033L6.86204 0.871668C7.28204 0.434334 8.00004 0.744334 8.00004 1.36233V10.6383C8.00004 11.261 7.27337 11.5683 6.85604 11.1223L4.86271 8.87633C4.80177 8.81055 4.72794 8.75802 4.64582 8.722C4.5637 8.68599 4.47504 8.66727 4.38537 8.667H2.00004C1.63204 8.667 1.33337 8.35633 1.33337 7.973Z",
    stroke: "#8B8B8B",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSpeakerOff, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/speakerOff.7a7e4480.svg";
export { ForwardRef as ReactComponent };